'use memo';

import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { Text } from '@/components/Typography';
import { RuleInclusionsSection } from '@/features/device-assignment-rule/components';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { DeviceAssignmentRuleShell } from '../-components/DeviceAssignmentRuleShell';
import { RuleFormPage } from '../-components/RuleFormPage';
import { DEVICE_ASSIGNMENT_FEATURE_FLAG } from '../../-constants/featureFlags';
export const Route = createFileRoute('/_staff/devices/_list/rule-and-policy/system-exceptions/')({
  // 本番非公開: FeatureFlag OFF の間は直接 URL でも遷移させず ComingSoonCover へ戻す
  beforeLoad: () => {
    if (!featureFlags.check(DEVICE_ASSIGNMENT_FEATURE_FLAG)) {
      throw redirect({
        to: '/devices/rule-and-policy'
      });
    }
  },
  component: RouteComponent
});
function RouteComponent() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.ruleAndPolicy'
  });
  const navigate = useNavigate();
  useDocumentTitle(t('inclusions.systemTitle'));
  return <DeviceAssignmentRuleShell>
      <RuleFormPage title={t('inclusions.systemTitle')} onBack={() => navigate({
      to: '/devices/rule-and-policy'
    })} mode="view">
        <div className="flex flex-col gap-4">
          <Text variant="pSmall" className="text-neutral-muted-on-fill">
            {t('systemRule.description')}
          </Text>
          <RuleInclusionsSection mode="system" />
        </div>
      </RuleFormPage>
    </DeviceAssignmentRuleShell>;
}